import { render, staticRenderFns } from "./DialogAddEditInfraestructura.vue?vue&type=template&id=312d4a66"
import script from "./DialogAddEditInfraestructura.vue?vue&type=script&lang=js"
export * from "./DialogAddEditInfraestructura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports